module.exports = __webpack_public_path__ + "pc/img/logo.ebe743ec.svg";